const queueName = Object.freeze({
    SEGMENT_EVENT_QUEUE: 'segmentEventQueue'
  });
  
  export default queueName;
  